module.exports = __webpack_public_path__ + "static/media/fit.5927ef64.svg";